import { render, staticRenderFns } from "./ExpireActionSingle.vue?vue&type=template&id=46857c28"
import script from "./ExpireActionSingle.vue?vue&type=script&lang=js"
export * from "./ExpireActionSingle.vue?vue&type=script&lang=js"
import style0 from "./ExpireActionSingle.vue?vue&type=style&index=0&id=46857c28&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports